// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseVehicleDeviceManagementAdminAreaRoutes = {
  route: '/vehicle-device-management-admin',
}

export const VehicleDeviceManagementAdminAreaRoutes = transformRoutes(
  BaseVehicleDeviceManagementAdminAreaRoutes,
)
